import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class GameplayBackground extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {number} x 
   * @param {number} y 
   */
  constructor(scene, x, y) {
    super(scene, x, y);

    this.sceneX = x;
    this.sceneY = y;

    this.setup();
  }

  setup () {
    this.bg = ABCyaPhaser.Images.addImage(0,0,'bg', this).setOrigin(0);

    this.bg.displayWidth = this.scene.scale.width;
    this.bg.displayHeight = this.scene.scale.height;
    this.bg1 = ABCyaPhaser.Images.addImage(0,0, 'background_overlay', this).setOrigin(0);
    this.bg2 = ABCyaPhaser.Images.addImage(0,-this.bg1.height, 'background_overlay', this).setOrigin(0);
  }

  doClimb (value) {
    this.bg1.y += value;
    this.bg2.y += value;

    if (this.bg1.y >= this.scene.scale.height) {
      this.bg1.y = this.bg2.y - this.bg2.height;

      const tmp = this.bg1;
      this.bg1 = this.bg2;
      this.bg2 = tmp;
    }
  }
}